exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/global/_directives/sexy-chexy/sexy-chexy.component.less
// module id = ./src/app/global/_directives/sexy-chexy/sexy-chexy.component.less
// module chunks = 0